<template>
	<el-card shadow="never" class="aui-card--fill">
		<el-row style="background-color: #F3F4F4;">
			<el-col :xs="24" :md="6" style="line-height: 40px;font-size: 16px;color: #121212;font-weight: bold;">
				<img style="width: 16px;height: 16px;margin-right: 12px;" src="../../../assets/img/user-list.png" />
				开票记录
			</el-col>
			<el-col :xs="24" :md="18">
				<el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" style="text-align: right;">
					<el-form-item>
						<el-button v-if="$hasPermission('plat:platticketrecord:export')" type="primary" @click="exportHandle()">{{ $t('export') }}</el-button>
					</el-form-item>
					<el-form-item><el-button type="info" @click="getDataList()">刷新</el-button></el-form-item>
					<el-form-item>
						<el-button v-if="$hasPermission('plat:platticketrecord:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
					</el-form-item>
				</el-form>
			</el-col>
		</el-row>
		<div class="mod-plat__platticketrecord}">
			<el-form style="padding:10px;" :label-width="'140px'" :model="dataForm" ref="loginFormRef" @keyup.enter.native="getDataList()">
				<el-row>
					<el-col :md="12" :lg="8">
						<el-form-item label="开票申请编号:" prop="ticketApplyCode"><el-input style="width: 95%;" v-model="dataForm.ticketApplyCode" placeholder="开票申请编号" clearable></el-input></el-form-item>
					</el-col>
					<el-col :md="12" :lg="8">
						<el-form-item label="购买方企业名称:" prop="buyerName"><el-input style="width: 95%;" v-model="dataForm.buyerName" placeholder="购买方企业名称" clearable></el-input></el-form-item>
					</el-col>
					<el-col :md="12" :lg="8">
						<el-form-item label="统一社会信用编码:" prop="taxCode"><el-input style="width: 95%;" v-model="dataForm.taxCode" placeholder="统一社会信用编码" clearable></el-input></el-form-item>
					</el-col>
					<el-col :md="12" :lg="8">
						<el-form-item label="开票状态:" prop="ticketStatus">
							<el-select style="width: 95%;" v-model="dataForm.ticketStatus" placeholder="开票状态" clearable filterable>
								<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" :disabled="item.disabled"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :md="24" :lg="8">
						<el-form-item label="申请时间:" prop="applyDate">
							<el-date-picker style="width: 40%;" v-model="dataForm.applyDate" placeholder="开始时间" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
							-
							<el-date-picker style="width: 40%;" v-model="dataForm.startDate" placeholder="结束时间" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :md="12" :lg="8">
						<el-form-item label="开票时间:" prop="finishDate">
							<!--<el-input v-model="dataForm.finishDate" placeholder="开票申请编号" clearable></el-input>-->
							<el-date-picker style="width: 40%;" v-model="dataForm.finishDate" placeholder="开始时间" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
							-
							<el-date-picker style="width: 40%;" v-model="dataForm.endDate" placeholder="结束时间" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
						</el-form-item>
					</el-col>
				</el-row>

				<el-row>
					<el-col :md="24" :lg="24">
						<el-form-item :label-width="'20px'" style="text-align: right;">
							<el-button type="primary" @click="getDataList()">{{ $t('query') }}</el-button>
							<el-button type="info" @click="resetLoginForm">重置</el-button>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<el-table v-loading="dataListLoading" :data="dataList" @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
				<el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
				<el-table-column label="序号" type="index" width="50" align="center">
					<template slot-scope="scope">
						<span>{{ (page - 1) * limit + scope.$index + 1 }}</span>
					</template>
				</el-table-column>
				<!--<el-table-column prop="id" label="" header-align="center" align="center"></el-table-column>-->
				<el-table-column prop="ticketApplyCode" label="开票申请编号" header-align="center" align="center"></el-table-column>
				<el-table-column prop="buyerName" label="购买方企业名称" header-align="center" align="center"></el-table-column>
				<el-table-column prop="taxCode" label="统一社会信用编码" header-align="center" align="center"></el-table-column>
				<el-table-column prop="ticketType" label="发票类型" header-align="center" align="center"></el-table-column>
				<el-table-column prop="money" label="含税金额（元）" header-align="center" align="center"></el-table-column>
				<el-table-column prop="ticketStatus" label="开票状态" header-align="center" align="center">
					<template slot-scope="scope">
						<el-tag v-if="scope.row.ticketStatus == 0" size="small" type="danger">草稿</el-tag>
						<el-tag v-else-if="scope.row.ticketStatus == 1" size="small" type="warning">待审核</el-tag>
						<el-tag v-else-if="scope.row.ticketStatus == 2" size="small" type="success">已审核</el-tag>
						<el-tag v-else size="small" type="info">已开票</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="ticketBody" label="开票主体名称" header-align="center" align="center"></el-table-column>
				<!-- <el-table-column prop="expressCode" label="开票单号" header-align="center" align="center"></el-table-column>-->
				<el-table-column prop="applyDate" label="申请时间" header-align="center" align="center"></el-table-column>
				<el-table-column prop="finishDate" label="开票完成时间" header-align="center" align="center"></el-table-column>

				<el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
				  <template slot-scope="scope">
					<el-button type="text" size="small" @click="childHandle(scope.row.dealApprovalId)">查看详情</el-button>
				  </template>
				</el-table-column>
			</el-table>
			<el-pagination
				background
				:current-page="page"
				:page-sizes="[10, 20, 50, 100]"
				:page-size="limit"
				:total="total"
				layout="total, sizes, prev, pager, next, jumper"
				@size-change="pageSizeChangeHandle"
				@current-change="pageCurrentChangeHandle"
			></el-pagination>
			<!-- 弹窗, 新增 / 修改 -->
			<add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
		</div>
	</el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './platticketrecord-add-or-update'
import { addDynamicRoute } from '@/router'
import Cookies from 'js-cookie'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      options: [

        {
          value: '0',
          label: '草稿'
        },
        {
          value: '1',
          label: '待审核'
        },
        {
          value: '3',
          label: '已开票'
        }
      ],
      value: '',
      role: Cookies.get('admin_role'),
      mixinViewModuleOptions: {
        getDataListURL: '/sys/plat/platticketrecord/page',
        getDataListIsPage: true,
        deleteURL: '/sys/plat/platticketrecord',
        deleteIsBatch: true,
        exportURL: '/sys/plat/platticketrecord/export'
      },
      dataForm: {
        id: '',
        ticketApplyCode: '',
        buyerName: '',
        taxCode: '',
        startDate: '',
        ticketStatus: '',
        status: '',
        endDate: '',
        finishDate: '',
        applyDate: ''
      }
    }
  },
  components: {
    AddOrUpdate
  },
  methods: {
    // 点击重置按钮，重置登陆表单
    // 1.在表单中引入ref="loginFormRef"属性，loginFormRef值可以自定义；
    // 2.给重置按钮绑定点击事件：@click="resetLoginForm"；
    // 3.实现点击事件触发的方法，得到引入的属性值对象，调用resetFields方法，即：this.$refs.loginFormRef.resetFields()
    resetLoginForm () {
      this.$refs.loginFormRef.resetFields()
      this.dataForm.startDate = ''
      this.dataForm.endDate = ''

      this.getDataList()
    },
    childHandle (id) {
		  // 路由参数
		  const routeParams = {
        routeName: `${this.$route.name}__申请发票`,
        title: `申请发票`,
        path: 'plat/platinvoicingtasklist-add',
        params: {
          id: id
        }
		  }
		  // 动态路由
		  addDynamicRoute(routeParams, this.$router)
    }
  }
}
</script>
